import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
import { useAuth } from '../context/AuthContext';
import SEO from '../components/SEO';
import Products from './Products';

const Shop = () => {
  const { t } = useLanguage();
  const { isAdmin } = useAuth();

  // Admins can access the products page
  if (isAdmin()) {
    return <Products />;
  }

  // Non-admin users see "under development" message
  return (
    <>
      <SEO
        title={t('shop.pageTitle')}
        description={t('shop.pageDescription')}
        keywords={t('seo.shop.keywords')}
        type="website"
      />

      <section className="relative bg-gradient-to-br from-racing-black via-racing-darkGray to-gray-900 text-white py-32 md:py-48">
        <div className="container-custom">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center max-w-3xl mx-auto"
          >
            <div className="mb-8">
              <svg className="w-24 h-24 mx-auto text-racing-red" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
              </svg>
            </div>
            
            <h1 className="text-4xl md:text-5xl font-display font-bold mb-6">
              {t('shop.title')}
            </h1>
            
            <p className="text-xl text-gray-300 mb-12">
              {t('shop.message')}
            </p>

            <Link
              to="/contact"
              className="inline-block px-8 py-4 bg-racing-red hover:bg-red-700 text-white font-semibold text-lg rounded-lg transition-colors shadow-lg hover:shadow-xl"
            >
              {t('nav.contact')}
            </Link>
          </motion.div>
        </div>
      </section>
    </>
  );
};

export default Shop;
